import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from '../guards/auth.guard';
import { LayoutContainerComponent } from '../layout/layout-container.component';
import { EcoLayoutContainerComponent } from './eco/layout/eco-layout-container.component';


const routes: Routes = [
{
   path: 'dashboard',
  component: LayoutContainerComponent,
  canActivate: [ AuthGuard ],
  loadChildren: () => import('./child-routes.module').then(m => m.ChildRoutesModule)
},
{
  path: 'eco',
  component: EcoLayoutContainerComponent,
  canActivate: [ AuthGuard ],
  loadChildren: () => import('./eco/eco.module').then(m => m.EcoModule)
},
{
  path: 'uco',
  component: LayoutContainerComponent,
  canActivate: [ AuthGuard ],
  loadChildren: () => import('./uco/uco.module').then(m => m.UcoModule)
},
{
  path: 'management',
  component: LayoutContainerComponent,
  canActivate: [ AuthGuard ],
  loadChildren: () => import('./management/management.module').then(m => m.ManagementModule)
},
{
  path: 'data-maintenance',
  redirectTo: 'management/data-maintenance',
  pathMatch: 'full'
}

];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule]
})

export class PagesRoutingModule {}
